module.exports = __webpack_public_path__ + "static/media/SSP governo.0f71caae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SSP governo.png
// module id = 245
// module chunks = 0